import { render, staticRenderFns } from "./Receipts.vue?vue&type=template&id=1d9b0181&"
import script from "./Receipts.vue?vue&type=script&lang=js&"
export * from "./Receipts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d9b0181')) {
      api.createRecord('1d9b0181', component.options)
    } else {
      api.reload('1d9b0181', component.options)
    }
    module.hot.accept("./Receipts.vue?vue&type=template&id=1d9b0181&", function () {
      api.rerender('1d9b0181', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/receipts/views/Receipts.vue"
export default component.exports